import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '12fr 8fr 2fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    backgroundColor: theme.palette.background.paper,
    marginTop: 4,
    borderRadius: 12
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    color: theme.palette.text.secondary,
    padding: '0 0 0 12px',
    backgroundColor: theme.palette.background.paper,
    marginBottom: 4,
    marginTop: 4,
    borderRadius: 12,
    alignItems: 'center'
  },
  tableRowRoot: {
    display: 'grid',
    gridTemplateColumns: '22fr 1fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '12fr 8fr 2fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    width: '100%',
    textAlign: 'unset'
  },
  tableRowSkeleton: {
    display: 'grid',
    gridTemplateColumns: '12fr 8fr 3fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    width: '100%',
    textAlign: 'unset',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '7fr 3fr'
    }
  },
  tableRowMobile: {
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    height: 60,
    alignItems: 'center',
    transition: 'background-color 0.3s ease-in-out',
    borderRadius: 20,
    cursor: 'initial',
    paddingLeft: 12
  },
  userLogo: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: '#dfdfdf',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12
  },
  nameCell: {
    display: 'flex'
  },
  moreIcon: {
    cursor: 'pointer'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  skeleton: {
    width: '80%'
  },
  userInfoContainerSkeleton: {
    width: '80%'
  },
  userInfoNameSkeleton: {
    width: '80%'
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  cursorDefault: {
    cursor: 'default'
  },
  rowMenu: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }
}))

export default useStyles
